var __jsx = React.createElement;
import React from "react";
var CustomCheckbox = function CustomCheckbox(_ref) {
  var checked = _ref.checked,
    onChange = _ref.onChange,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    inputRef = _ref.inputRef;
  return /*#__PURE__*/React.createElement("label", {
    className: "relative cursor-pointer flex items-center ".concat(className)
  }, /*#__PURE__*/React.createElement("input", {
    ref: inputRef,
    type: "checkbox",
    checked: checked,
    onChange: onChange,
    className: "opacity-0 absolute h-5 w-5 cursor-pointer peer"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-5 w-5 rounded flex items-center justify-center transition-colors duration-150\n          ".concat(checked ? "bg-teal-500" : "bg-gray-200 dark:bg-gray-800", "\n          border border-gray-400 dark:border-gray-600\n        ")
  }, checked && /*#__PURE__*/React.createElement("svg", {
    className: "w-3 h-3 text-gray-900 dark:text-white",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "3",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 13l4 4L19 7"
  }))));
};
export default CustomCheckbox;